import { useDeploymentLineLegalPublisher } from "@Front/Services/DeploymentLineLegalPublisher/DeploymentLineLegalPublisherContext";

import { LegalNoticeEditor } from "./LegalNoticeEditor";
import { LegalNoticeHoster } from "./LegalNoticeHoster";
import { LegalNoticeOwner } from "./LegalNoticeOwner";
import { LegalNoticeLine, LegalNoticeMailLink } from "./LegalNoticePrimitives";

/** Blocs propriétaire / éditeur / hébergeur des mentions légales. */
export function LegalNoticePublisher(): React.JSX.Element {
	const { legalNotice } = useDeploymentLineLegalPublisher();
	return (
		<>
			<LegalNoticeOwner notice={legalNotice} />
			<LegalNoticeEditor notice={legalNotice} />
			<LegalNoticeHoster notice={legalNotice} />
			<LegalNoticeLine>
				{legalNotice.questionsLeadIn} <LegalNoticeMailLink email={legalNotice.ownerContactEmail} />.
			</LegalNoticeLine>
		</>
	);
}
